import { InputLabel } from "@components/ui/Typography";
import Api from "@services/Api";
import { toastError, toastMessage } from "@util/functions";
import { Plan, PlanFormValues } from "@util/interfaces";
import { Field, Form, Formik, FormikHelpers } from "formik";
import * as React from "react";
import { useHistory, useParams } from "react-router";
import {
  ContentContainer,
  LoadingIndicator,
  PageTitle,
  RootContainer,
  TitleContainer,
} from "@components/ui/PageBaseComponents";

type EditPlanProps = {
  plan_id?: string;
};

const EditPlanScreen: React.FC = () => {
  const history = useHistory();
  const { plan_id } = useParams<EditPlanProps>();
  const [loading, setLoading] = React.useState(true);
  const [plan, setPlan] = React.useState<Plan>();

  React.useEffect(() => {
    fetchPlanDetails();
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    if (plan) setLoading(false);
  }, [plan]);

  const fetchPlanDetails = async () => {
    try {
      const { data } = await Api.get(`/plan/id/${plan_id}`);
      setPlan(data.plans);
    } catch (error) {
      setLoading(false);
      toastError(error);
    }
  };

  const handleSubmit = async (values: PlanFormValues, actions: FormikHelpers<PlanFormValues>) => {
    try {
      actions.setSubmitting(true);
      await Api.patch(`/plan/${plan_id}`, values);
      toastMessage("Plano atualizado", "success");
      actions.setSubmitting(true);
      history.push("/planos");
    } catch (error) {
      actions.setSubmitting(true);
      toastError(error);
    }
  };

  const initialValues: PlanFormValues = {
    name: plan?.name,
    price_monthly: plan?.price_monthly,
    price_yearly: plan?.price_yearly,
    price_semesterly: plan?.price_semesterly,
    allow_cover_image: plan?.allow_cover_image,
    allow_logo_image: plan?.allow_logo_image,
    allow_product_images: plan?.allow_product_images,
    product_images_limit: plan?.product_images_limit,
  };

  if (loading || !plan)
    return (
      <RootContainer>
        <TitleContainer>
          <PageTitle>Editar plano</PageTitle>
        </TitleContainer>
        <ContentContainer>
          <LoadingIndicator />
        </ContentContainer>
      </RootContainer>
    );

  return (
    <RootContainer>
      <TitleContainer>
        <PageTitle>Editar plano</PageTitle>
      </TitleContainer>
      <ContentContainer>
        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
          {({ isSubmitting, values }) => (
            <Form>
              <div className="row m-0 p-0">
                <div className="mb-4 col-md-3">
                  <InputLabel>Nome do plano</InputLabel>
                  <Field name="name" className="form-control" placeholder="Digite o nome" required />
                </div>
                <div className="mb-4 col-md-3">
                  <InputLabel>Preço mensal</InputLabel>
                  <Field name="price_monthly" className="form-control" placeholder="Digite o preço mensal" required />
                </div>
                <div className="mb-4 col-md-3">
                  <InputLabel>Preço semestral</InputLabel>
                  <Field
                    name="price_semesterly"
                    className="form-control"
                    placeholder="Digite o preço semestral"
                    required
                  />
                </div>
                <div className="mb-4 col-md-3">
                  <InputLabel>Preço anual</InputLabel>
                  <Field name="phone_2" className="form-control" placeholder="Digite o preço anual" />
                </div>
                <div className="mb-4 col-md-3">
                  <InputLabel>Permitir logo da empresa?</InputLabel>

                  <div className="form-check">
                    <Field type="checkbox" className="form-check-input" name="allow_logo_image" id="allow_logo_image" />
                    <label className="form-check-label" htmlFor="allow_logo_image">
                      {`${values.allow_logo_image ? "Sim" : "Não"}`}{" "}
                    </label>
                  </div>
                </div>
                <div className="mb-4 col-md-3">
                  <InputLabel>Permitir imagem de capa?</InputLabel>

                  <div className="form-check">
                    <Field
                      type="checkbox"
                      className="form-check-input"
                      name="allow_cover_image"
                      id="allow_cover_image"
                    />
                    <label className="form-check-label" htmlFor="allow_cover_image">
                      {`${values.allow_cover_image ? "Sim" : "Não"}`}{" "}
                    </label>
                  </div>
                </div>
                <div className="mb-4 col-md-3">
                  <InputLabel>Permitir imagens de produtos?</InputLabel>

                  <div className="form-check">
                    <Field
                      type="checkbox"
                      className="form-check-input"
                      name="allow_product_images"
                      id="allow_product_images"
                    />
                    <label className="form-check-label" htmlFor="allow_product_images">
                      {`${values.allow_product_images ? "Sim" : "Não"}`}{" "}
                    </label>
                  </div>
                </div>
                <div className="mb-4 col-md-3">
                  <InputLabel>Qual o limite de imagens de produtos?</InputLabel>
                  <Field
                    name="product-images-limit"
                    className="form-control"
                    placeholder="Digite o limite de imagens"
                  />
                </div>

                <div className="col-12">
                  <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                    {isSubmitting ? "enviando" : "enviar"}
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </ContentContainer>
    </RootContainer>
  );
};

export default EditPlanScreen;
